import setupPhotoswipe from './../new-car-pages/modules/details/setup-photoswipe';
import setupDealerMap from './../new-car-pages/modules/details/setup-dealer-map';
// import setupRequestCallback from './forms/modules/request-callback';
import setupSendEnquiry from './forms/modules/send-enquiry';
// import setupSendFinanceEnquiry from './forms/modules/send-finance-enquiry';
import setupContractHireFixedQuote from './forms/modules/contract-hire-fixed-quote';
import initialiseFinance from '../new-car-pages/modules/details/initialise-finance';
setupPhotoswipe();
setupDealerMap();
setupSendEnquiry();
setupContractHireFixedQuote();
const detailsElement = document.querySelector('.new-car-details');
if (detailsElement && detailsElement.dataset.vehicleType == 'van') {
    initialiseFinance();
}


// WEBPACK FOOTER //
// ./resources/assets/js/fleet-and-business/show-es6.js